<template>
  <div class="ly-no-data">
    <p class="text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.ly-no-data {
  display: flex;
  margin : {
    top: 5px;
    bottom: 5px;
  }
  height: 98%;
  align-items: center;
  justify-content: center;
  background: $--color-white-smoke;
  border-radius: 10px;
  .text {
    width: 225px;
    line-height: 26px;
    font-size: $--font-size-base;
    color: $--text-nodata;
    text-align: center;
  }
}
</style>
